/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Alter_Scores_WarningInputs */



/**
* | output |
* | --- |
* | "Moving a player to another table, or removing them from the round, resets their scores." |
*
* @param {Rounds_Alter_Scores_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_alter_scores_warning = /** @type {((inputs?: Rounds_Alter_Scores_WarningInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Alter_Scores_WarningInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déplacer un joueur vers une autre table, ou le retirer de la ronde, réinitialise ses scores.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mover a un jugador a otra mesa, o quitarlo de la ronda, restablece sus puntuaciones.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Mover um jogador para outra mesa, ou removê-lo da rodada, redefine suas pontuações.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spostare un giocatore a un altro tavolo, o rimuoverlo dal round, azzera i suoi punteggi.")
	return /** @type {LocalizedString} */ ("Moving a player to another table, or removing them from the round, resets their scores.")
});